import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

// ** found updated url by going to coast.noaa.gov and searching for Aids to Navigation
const url =  "https://coast.noaa.gov/arcgis/rest/services/Hosted/AtoNs/FeatureServer";

const portalId = "3b44085a647241509d2f9a9a370c2722";

export const layer = new FeatureLayer({
  portalItem: {
    id: portalId,
  },
  visible: true,
  title: "USCG Aids to Navigation - Zoom In",
  popupTemplate: {
    title: "{name}",
    content: `<b>Structure:</b> {structure}<hr/> <a href=${url}>More Info</a>`,
  },
  layerDescription: "USCG Aids to Navigation",
  mapService: url,
  authoritiveSource: `https://rutgers.maps.arcgis.com/home/item.html?id=${portalId}`,
});

export const uscgNav = {layerId: 'uscgNav', type: 'layer', item: layer, meta: layer}
  
